/* template */
<template minapp="mpx" xlang="wxml"><div class="es-calendar-week"><div v-for="(item, index) in (weeks)" :key="item" :class="({'es-calendar-week__holiday': item === '六' || item === '日'})" class="es-calendar-week__item">{{ item }}</div></div></template>

/* styles */
<style lang="css" mpxStyleOptions='{"mid":"m6cdf4de8"}'>
  .es-calendar-week {
    display: flex;
    line-height: 48px;
    padding: 0 6px;
  }
  .es-calendar-week__item {
    flex: 1;
    font-size: 14px;
    text-align: center;
    font-family: PingFangSC-Regular;
  }

  .es-calendar-week__holiday {
    color: #1473ff;
  }
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m6cdf4de8"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./week.mpx.js?isComponent&outputPath=components%2Fweek6cdf4de8%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./week.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Fweek6cdf4de8%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m6cdf4de8"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/week6cdf4de8/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
